// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Order } from './order';
import { OrderLineDetail } from './order-line-detail';
import { OrderLineStatus } from './order-line-status';
import { Part } from './part';
import { Vin } from './vin';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
import { Utility } from '../utility';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class OrderLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static ACHDiscountPercentage = 0.02;
    static SalesTaxRate = 0.06;

    _displayOrder: number;
    get displayOrder() {
        if (!this._displayOrder) this._displayOrder = 10000 * (!!this.parentLine ? this.parentLine.lineNumber : this.lineNumber) + this.lineNumber;
        return this._displayOrder;
    }

    get vinDisplay() {
        // if (!this.orderLineDetails) return;
        let vinName = '';
        if (!!this.orderLineDetails && this.orderLineDetails.length > 0 && !this.isOption && !this.isReplacement && !!this.partId) {
            this.orderLineDetails.forEach((vin) => {
                if (!!vin.vIN && !vin.deleted) vinName = `${vinName}${vin.vIN}; `;
            });
        }
        return vinName;
    }

    get orderLineDetailStatuses() {
        if (!this.orderLineDetails) return;

        const statusArray = [];
        this.orderLineDetails.forEach((detail) => {
            if (!!detail.status && !detail.deleted) {
                const findStatus = _.find(statusArray, { name: detail.status.name }) as any;
                if (!findStatus) {
                    statusArray.push({ count: 1, name: detail.status.name });
                } else {
                    findStatus.count = findStatus.count + 1;
                }
            }
        });

        let statusString = '';
        statusArray.forEach((status) => {
            statusString += `${status['name']} [${status['count']}]; `;
        });
        return statusString;
    }

    delete(recursive = true) {
        if (recursive) {
            while (this.children.length > 0) {
                this.children[0].delete(recursive);
            }
        }
        this.entityAspect.setDeleted();
    }

    get achLineAmount() {
        return this.prePaymentDiscountOverride ? this.price : Utility.round(this.price * (1 - OrderLine.ACHDiscountPercentage), 2);
    }

    get lineTotal() {
        return !!this.paidAch ? this.quantity * this.achLineAmount : this.quantity * this.price;
    }

    // get lineTax() {
    //     let tax = 0;
    //     if (this.order && this.order.type.taxable) {
    //         if (this.part && this.part.partPartTypes && this.part.partPartTypes.length > 0) {
    //             const nonTaxable = _.some(this.part.partPartTypes, (x) => {
    //                 return x.partTypeId === PartType.Types.NonTaxable;
    //             });
    //             if (!nonTaxable) {
    //                 tax = this.quantity * this.price * OrderLine.SalesTaxRate;
    //             }
    //         }
    //     }
    //     return tax;
    // }

    get linePrice() {
        return !!this.paidAch ? this.achLineAmount : this.price;
    }

    get partNumberWithPrice() {
        return `${this.partNumber} ${this.linePrice.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        })}`;
    }

    get orderLineDetailList() {
        if (!this.orderLineDetails) return;
        let details = [];
        this.orderLineDetails.forEach((detail) => {
            if (!detail.deleted) details.push(detail.id);
        });
        return details.join('; ');
    }

    get detailTotal() {
        let total = 0;
        if (this.orderLineDetails.length > 0) {
            this.orderLineDetails.forEach((detail) => {
                if (!detail.deleted) {
                    total += detail.price;
                }
            });
        }
        return total;
    }
    get detailPaymentTotal() {
        let total = 0;
        if (this.orderLineDetails.length > 0) {
            this.orderLineDetails.forEach((detail) => {
                if (!detail.deleted) {
                    if (detail.paymentLines && detail.paymentLines.length > 0) {
                        detail.paymentLines
                            .filter((line) => line.deleted === null)
                            .forEach((line) => {
                                total += line.amount;
                            });
                    }
                }
            });
        }
        return total;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  category?: string;
  cost!: number;
  creditRestock!: boolean;
  deleted?: Date;
  description?: string;
  extendedQuantity!: number;
  isCredit!: boolean;
  isFreight!: boolean;
  isMisc!: boolean;
  isNonManufactured!: boolean;
  isOption!: boolean;
  isReplacement!: boolean;
  lineNumber!: number;
  note?: string;
  orderId!: number;
  originalPrice!: number;
  paidAch?: Date;
  parentLineId?: number;
  partId?: number;
  partNumber?: string;
  prePaymentDiscountOverride!: boolean;
  price!: number;
  priceAch!: number;
  quantity!: number;
  quotedPrice!: number;
  returnedDetailId?: number;
  statusId?: number;
  submitted?: Date;
  tax!: number;
  tierPricingOverride!: boolean;
  children!: OrderLine[];
  order!: Order;
  orderLineDetails!: OrderLineDetail[];
  parentLine!: OrderLine;
  part!: Part;
  returnedDetail!: OrderLineDetail;
  status!: OrderLineStatus;
  vins!: Vin[];
}

